import { useState } from "react";
import { useProfile } from "@/hooks/useProfile";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Copy, Check, Code2 } from "lucide-react";
import { toast } from "sonner";

export default function Embed() {
  const [copied, setCopied] = useState(false);
  const { profile } = useProfile();
  const seg = (profile as any)?.segment || "homecare";

  const snippet = `<script>
  (function() {
    var s = document.createElement('script');
    s.src = '${window.location.origin}/widget.js';
    s.async = true;
    document.body.appendChild(s);
  })();
</script>`;

  function handleCopy() {
    navigator.clipboard.writeText(snippet);
    setCopied(true);
    toast.success("Snippet copied to clipboard!");
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="max-w-2xl space-y-6">
      <h2 className="text-2xl font-bold text-foreground">{seg === "grouphome" ? "Embed Your Intake Widget" : "Embed Your Chatbot"}</h2>
      <p className="text-muted-foreground">
        {seg === "grouphome"
          ? "Add your AI intake coordinator to your website by pasting this snippet before the closing "
          : "Add Sarah to your website by pasting this snippet before the closing "}
        <code className="rounded bg-muted px-1.5 py-0.5 text-sm">&lt;/body&gt;</code> tag.
      </p>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <Code2 className="h-4 w-4" />
            JavaScript Embed Snippet
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="relative">
            <pre className="overflow-x-auto rounded-lg bg-muted p-4 text-sm text-foreground">
              <code>{snippet}</code>
            </pre>
            <Button
              size="sm"
              variant="outline"
              onClick={handleCopy}
              className="absolute right-2 top-2 gap-1.5"
            >
              {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
              {copied ? "Copied" : "Copy"}
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Preview</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="rounded-lg border bg-muted/50 p-8 text-center">
            <p className="text-sm text-muted-foreground">
              The chat widget appears as a floating button in the bottom-right corner of your website.
              It's already active on this dashboard — try clicking the blue chat bubble!
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
